<template>
  <el-container
    class="container-list is-vertical webpage-content-editor"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item>網頁設計</el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.params.title}}</el-breadcrumb-item>
            <el-breadcrumb-item>內文</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <template slot="right">
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" style="padding-top: 50px !important;">

        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane v-for="lang in languages" :key="`content-page-${page.id}-lang-${lang}`" :label="getLabel(lang)" :name="lang" style="padding-left: 40px;">
            <!-- <c-k-editor-form :ref="`form-${lang}`" @input="onInput" :value="webInfos[`page-content-${page.id}-${lang}`]"></c-k-editor-form> -->
            <content-editor v-if="webInfos[`page-content-${page.id}-${lang}`]!=null" :is-template-enabled="false" v-model="webInfos[`page-content-${page.id}-${lang}`]" @input="()=>isUpdated=true"/>
          </el-tab-pane>
        </el-tabs>

        <el-button :disabled="!isUpdated" class="btn-upload" style="top: 12px;" type="primary" size="mini" @click="submit">送出<i class="el-icon-upload el-icon--right"></i></el-button>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// import CKEditorForm from './form-ckeditor'
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
// svgs
import '@/assets/svgs/index.js'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinLanguages],
  components: {
    LeftMenu,
    TopHeader,
    ContentEditor
  },
  data () {
    return {
      isLoading: false,
      isUpdated: false,
      webInfos: {},
      activeLang: 'Tw'
    }
  },
  computed: {
    page () {
      return { id: this.$route.params.page, title: '' }
    }
  },
  methods: {
    getLabel (str) {
      return {
        'Tw': '繁體中文',
        'Cn': '簡體中文',
        'En': '英文',
        'Jp': '日文'
      }[str] || '未知語言'
    },
    onInput () {
      this.isUpdated = true
    },
    submit () {
      var promiseList = []
      var payloads = []
      for (let obj of this.$store.state.webInfo.list) {
        if (!obj.ID.startsWith('page-content')) continue
        if (!obj.ID.startsWith('page-content-' + this.page.id)) continue

        if (JSON.stringify(this.webInfos[obj.ID]) === obj.Value) continue

        let payload = {
          ID: obj.ID,
          Value: JSON.stringify(this.webInfos[obj.ID]),
          UpdatedAt: (this.$store.state.webInfo.list.find(o => o.ID === obj.ID) || {}).UpdatedAt
        }
        payloads.push(payload)
        let promise = this.$services.webInfo.edit(this, payload)
        promiseList.push(promise)
      }

      if (promiseList.length === 0) {
        return alert('錯誤: 並未更動')
      }

      Promise.all(promiseList)
        .then(results => {
          let okCount = 0
          let errCount = 0

          for (var i = 0; i < results.length; i++) {
            let res = results[i]
            let ok = res && res.data && res.data.status === 'ok'
            okCount += ok ? 1 : 0
            errCount += !ok ? 1 : 0

            if (ok) {
              let newData = res.data.result
              let payload = payloads[i]
              let idx = this.$store.state.webInfo.list.findIndex(o => o.ID === payload.ID)
              if (idx < 0) console.error('更新異常，找不到 webInfo，idx null')
              this.$store.state.webInfo.list[idx].Value = payload.Value
              this.$store.state.webInfo.list[idx].UpdatedAt = newData.UpdatedAt
              this.$set(this.webInfos, payload.ID, JSON.parse(payload.Value))
            }
          }

          if (errCount === 0) {
            this.$message({
              message: `更新成功`,
              type: 'success'
            })
          } else if (okCount === 0) {
            console.error(results)
            this.$message.error(`更新異常!`)
          } else {
            this.$message({
              message: `${okCount}筆資料更新成功, ${errCount}筆資料更新異常`,
              type: 'warning'
            })
          }
        }).catch(this.$handleServiceError)
    },
    loadData () {
      for (let obj of this.$store.state.webInfo.list) {
        if (obj.ID.startsWith('page-content-' + this.page.id)) {
          console.log(obj.Value, JSON.parse(obj.Value))
          this.$set(this.webInfos, obj.ID, JSON.parse(obj.Value))
        }
      }
    }
  },
  created () {
    this.loadData()
  },
  filters: {
    label (str) {
      return {
        'Tw': '繁體中文',
        'Cn': '簡體中文',
        'En': '英文',
        'Jp': '日文'
      }[str] || '未知語言'
    }
  },
  watch: {
    page () {
      this.loadData()
    }
  }
}
</script>
